import React from "react";
import Image from "next/image";
import ContactUs from "@/components/pages/contact/contact-form";
import Section from "@/components/ui/section";
import Seo from "@/utils/seo";
import Head from "next/head";

import LottiePlayerLight from "react-lottie-player/dist/LottiePlayerLight";
import ContactAnimation from "../../public/animations/Animation - 1723883806646.json";

export default function ContactUsPage() {
  const seo = {
    slug: "/get-involved",
    metaTitle:
      "Charity Organization in USA | Contact Us | People’s Courage International",
    metaDescription:
      "We'd love to hear from you! Contact us to learn how you can be a part of our community and support our mission.",
  };
  const jsonLd = {
    "@context": "http://www.schema.org",
    "@type": "Organization",
    name: "People’s Courage International",
    description:
      "People’s Courage International is a USA-based not-for-profit organization. Join our charity and help us provide critical support to those in need around the world.",
    address: {
      "@type": "PostalAddress",
      streetAddress: "3206 10th Street NE, Washington",
      addressLocality: "DC",
      postalCode: "20017",
      addressCountry: "USA",
    },
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+1202-573-8727",
      contactType: "customer support",
    },
  };

  return (
    <>
      <Seo seo={seo} />
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(jsonLd),
          }}
        />
      </Head>
      <Section variant="flat" className="min-h-[calc(100vh-136px)]">
        <div className="flex lg:flex-row flex-col lg:gap-12 gap-6 w-full lg:py-12">
          <div className="relative lg:w-[400px] lg:h-[400px] md:w-full md:h-[250px] w-full h-[200px] shrink-0 rounded-2xl overflow-hidden">
            <Image
              src={"/images/contact/GET INVOLVED.webp"}
              alt={"contact-banner"}
              fill
              priority={true}
              className="object-cover object-center w-full"
              sizes="(max-width: 479px) 479px,(max-width: 768px) 768px, (max-width: 1200px) 1200px,(max-width: 1920px) 1920px, 1000px"
            />
          </div>

          <ContactUs />
        </div>
      </Section>
      {/* <Section className="bg-[#F5F5F5] overflow-hidden" variant="flat">
        <div className="flex md:flex-row flex-col-reverse items-center w-full justify-between lg:max-w-[1200px] mx-auto">
          <div className="flex flex-col w-fit gap-8 shrink-0 md:pb-0 pb-8">
            <div className="flex flex-col items-start justfify-start gap-2">
              <p className="text-body lg:text-[20px] text-base font-medium">
                Address
              </p>
              <p className="text-text">
                3206 10th Street NE, Washington, DC 20017
              </p>
            </div>
            <div className="flex flex-col items-start justfify-start gap-2">
              <p className="text-body lg:text-[20px] text-base font-medium">
                Email
              </p>
              <a
                className="text-text"
                href="mailto:info@peoplescourageinternational.org"
              >
                info@peoplescourageinternational.org
              </a>
            </div>
          </div>
          <div className="shrink-0 group flex justify-start items-start relative overflow-hidden lg:h-[350px] md:h-[200px] h-[200px] lg:w-[600px] md:w-[400px] w-full">
            <LottiePlayerLight loop animationData={ContactAnimation} play />
          </div>
        </div>
      </Section> */}
    </>
  );
}
